import { cn } from "@wags/ui/ui-utils";
import { VercelImage } from "@wags/ui/vercel-image.tsx";
import type { OtherDog } from "./other-dogs";

export function MoreDogsGalleryThumbnail({ dogs }: { dogs: OtherDog[] }) {
    const shown = dogs.slice(0, 4);
    return (
        <span
            className={cn(
                "grid size-full grid-cols-2 gap-px bg-doberman-black",
                shown.length > 2 && "grid-rows-2",
            )}
        >
            {shown.map((dog, index) => (
                <span
                    key={dog.id}
                    className={cn(
                        "block overflow-hidden bg-havanese",
                        shown.length === 3 && index === 0 && "row-span-2",
                    )}
                >
                    {dog.imageUrl ? (
                        <VercelImage
                            src={dog.imageUrl}
                            listingMedia
                            alt=""
                            width={56}
                            height={56}
                            className="size-full object-cover"
                            videoMode="thumbnail"
                        />
                    ) : null}
                </span>
            ))}
        </span>
    );
}
